import { Component, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from '@shared/components/header/header.component';
import { EmptyListComponent } from '@shared/components/empty-list/empty-list.component';
import { FuncionalidadeEnum } from '@shared/enums/usuario/funcionalidade.enum';
import { ModuloEnum } from '@shared/enums/usuario/modulo.enum';

interface ConfigServicosMenuItem {
  label: string;
  route: string;
  icon: string;
}

interface ConfigServicosMenuGroup {
  title: string;
  items: ConfigServicosMenuItem[];
}

@Component({
  selector: 'app-config-servicos',
  standalone: true,
  imports: [
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    HeaderComponent,
    EmptyListComponent,
    MatButtonModule,
    ReactiveFormsModule,
  ],
  templateUrl: './config-servicos.component.html',
  styleUrls: ['./config-servicos.component.css'],
})
export class ConfigServicosComponent implements OnInit {
  public moduloEnum = ModuloEnum.Configuracoes;
  public funcionalidadeEnum = FuncionalidadeEnum.Configuracoes_Servicos;

  public menuGroups: ConfigServicosMenuGroup[] = [
    {
      title: 'Geral',
      items: [
        { label: 'Tags de ordem de serviço', route: 'tags-ordem-servico', icon: 'sell' },
        { label: 'Tags de contrato', route: 'tags-contrato', icon: 'sell' },
        { label: 'Envio de documentos', route: 'envio-documentos', icon: 'send' },
      ],
    },
    {
      title: 'Ordens de serviço',
      items: [
        { label: 'Configurações gerais de ordem de serviço', route: 'gerais', icon: 'build' },
        { label: 'Kanban de ordem de serviço', route: 'kanban', icon: 'view_kanban' },
        { label: 'Automações de ordem de serviço', route: 'automacoes', icon: 'bolt' },
        { label: 'Campos adicionais', route: 'campos-adicionais', icon: 'playlist_add' },
        { label: 'Motivos de transição', route: 'motivos-transicao', icon: 'swap_horiz' },
      ],
    },
    {
      title: 'Fiscal',
      items: [{ label: 'Cadastro de CNAEs', route: 'cnaes', icon: 'pin' }],
    },
  ];

  public filteredMenuGroups: ConfigServicosMenuGroup[] = [];
  public pesquisaControl = new FormControl('');

  ngOnInit(): void {
    this.pesquisaControl.valueChanges.subscribe(() => {
      this.filtrar();
    });
    this.filtrar();
  }

  public filtrar(): void {
    const termo = this.removeAcentos(this.pesquisaControl.value?.toLowerCase() || '');
    if (!termo) {
      this.filteredMenuGroups = [...this.menuGroups];
      return;
    }

    this.filteredMenuGroups = this.menuGroups
      .map(group => {
        const groupMatches = this.removeAcentos(group.title.toLowerCase()).includes(termo);
        const items = groupMatches
          ? group.items
          : group.items.filter(item => this.removeAcentos(item.label.toLowerCase()).includes(termo));

        return { ...group, items };
      })
      .filter(group => group.items.length > 0);
  }

  public get nenhumResultado(): boolean {
    return this.filteredMenuGroups.length === 0;
  }

  private removeAcentos(str: string): string {
    return str.normalize('NFD').replace(/[̀-ͯ]/g, '');
  }
}
